import { Dispatch, SetStateAction } from 'react';
import { parse as queryString } from 'query-string';

export function handleClick(
	divisionCode: string,
	setDivisionNumber: Dispatch<SetStateAction<string>>
): () => void {
	return function () {
		setDivisionNumber(divisionCode);

		const { search: searchQuery, filter: filterQuery } = queryString(document.location.search);
		if (typeof searchQuery === 'string' && typeof filterQuery === 'string') {
			window.history.pushState(
				null,
				'',
				`${document.location.pathname}?search=${searchQuery}&filter=${filterQuery}&division=${divisionCode}`
			);
		}
	};
}
